import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "top_area" }
const _hoisted_2 = { id: "main_area" }
const _hoisted_3 = {
  key: 0,
  class: "global-loading-overlay"
}
const _hoisted_4 = { class: "footer" }

import NavBar from '@/components/NavBar.vue';
import MyModal from "@/components/modals/MyModal.vue";
import CheckingModal from "@/components/modals/CheckingModal.vue";
import {useServerInfoStore} from "@/stores/serverInfo";
import {useClientStore} from "@/stores/clientState";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const serverInfoStore = useServerInfoStore();
const clientState = useClientStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NavBar)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(clientState).loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 載入中... "))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_unref(serverInfoStore).server_info.site_name), 1),
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("Powered by ", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("a", { href: "https://github.com/LittleOrange666/OrangeJudge" }, "OrangeJudge", -1)),
        _createTextVNode(" " + _toDisplayString(_unref(serverInfoStore).server_info.version_info), 1)
      ])
    ]),
    _createVNode(MyModal),
    _createVNode(CheckingModal)
  ], 64))
}
}

})